module.exports = __webpack_public_path__ + "img/helpyou2.177e1cda.jpg";